// Intermodal Container Types and Sizes
export const CONTAINER_TYPES = [
  // Standard Dry Containers
  { value: "20' Dry", label: "20' Standard Dry", type: "Dry" },
  { value: "40' Dry", label: "40' Standard Dry", type: "Dry" },
  { value: "40' HC Dry", label: "40' High Cube Dry", type: "Dry" },
  { value: "45' HC Dry", label: "45' High Cube Dry", type: "Dry" },
  
  // Domestic Containers
  { value: "53' Domestic", label: "53' Domestic", type: "Domestic" },
  
  // Refrigerated Containers (Reefer)
  { value: "20' Reefer", label: "20' Refrigerated (Reefer)", type: "Reefer" },
  { value: "40' Reefer", label: "40' Refrigerated (Reefer)", type: "Reefer" },
  { value: "40' HC Reefer", label: "40' High Cube Reefer", type: "Reefer" },
  { value: "45' HC Reefer", label: "45' High Cube Reefer", type: "Reefer" },
  
  // Open Top Containers
  { value: "20' Open Top", label: "20' Open Top", type: "Open Top" },
  { value: "40' Open Top", label: "40' Open Top", type: "Open Top" },
  { value: "40' HC Open Top", label: "40' High Cube Open Top", type: "Open Top" },
  
  // Flat Rack Containers
  { value: "20' Flat Rack", label: "20' Flat Rack", type: "Flat Rack" },
  { value: "40' Flat Rack", label: "40' Flat Rack", type: "Flat Rack" },
  { value: "40' Collapsible Flat Rack", label: "40' Collapsible Flat Rack", type: "Flat Rack" },
  
  // Tank Containers
  { value: "20' Tank", label: "20' ISO Tank", type: "Tank" },
  { value: "40' Tank", label: "40' ISO Tank", type: "Tank" },
  
  // Platform/Bolster Containers
  { value: "20' Platform", label: "20' Platform/Bolster", type: "Platform" },
  { value: "40' Platform", label: "40' Platform/Bolster", type: "Platform" },
];

// Simple list for backward compatibility
export const CONTAINER_SIZES = [
  "20' Dry",
  "40' Dry",
  "40' HC Dry",
  "45' HC Dry",
  "53' Domestic",
  "20' Reefer",
  "40' Reefer",
  "40' HC Reefer",
  "45' HC Reefer",
  "20' Open Top",
  "40' Open Top",
  "40' HC Open Top",
  "20' Flat Rack",
  "40' Flat Rack",
  "40' Collapsible Flat Rack",
  "20' Tank",
  "40' Tank",
  "20' Platform",
  "40' Platform",
];

// Grouped by type for better UX
export const CONTAINER_GROUPS = {
  "Standard Dry": ["20' Dry", "40' Dry", "40' HC Dry", "45' HC Dry"],
  "Domestic": ["53' Domestic"],
  "Refrigerated": ["20' Reefer", "40' Reefer", "40' HC Reefer", "45' HC Reefer"],
  "Open Top": ["20' Open Top", "40' Open Top", "40' HC Open Top"],
  "Flat Rack": ["20' Flat Rack", "40' Flat Rack", "40' Collapsible Flat Rack"],
  "Tank": ["20' Tank", "40' Tank"],
  "Platform": ["20' Platform", "40' Platform"]
};
